import {
  GET_IMPRESSIONS_LIST,
  GET_IMPRESSIONS_LIST_SUCCESS,
  GET_IMPRESSIONS_LIST_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getImpressionsListReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_IMPRESSIONS_LIST:
      return { ...state, loading: true };
    case GET_IMPRESSIONS_LIST_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_IMPRESSIONS_LIST_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getImpressionsListReducer;
